import React from 'react';
import Link from 'next/link';

// Products, singles and auction lots share image dimensions and content rhythm.
// Feature components supply pricing and actions; this shell never makes purchases.
// `overlay` (the wishlist heart) sits over the image's top-right corner as a
// sibling of the link: a button inside it would be invalid and would navigate.
export default function CatalogCard({ href, title, image, priority = false, badge, priceMetadata, price, action, overlay }) {
  return <article className="relative grid min-w-0 content-start gap-2">
    <Link href={href} className="group grid min-w-0 gap-2 rounded-xl text-krit-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-700 focus-visible:ring-offset-2">
      <span data-catalog-image className="relative block aspect-square overflow-hidden rounded-xl bg-white p-3 max-[768px]:h-48 max-[768px]:aspect-auto max-[425px]:h-40">
        <img src={image} alt={title} width="240" height="240" decoding="async" loading={priority ? 'eager' : 'lazy'}
          className="!h-full !w-full object-contain transition-transform duration-200 motion-safe:group-hover:scale-[1.03]" />
        {badge && <span className="absolute left-2 top-2 max-w-[calc(100%_-_1rem)]">{badge}</span>}
      </span>
      <span title={title} className="line-clamp-3 h-12 break-words text-[12px] font-bold leading-4 min-[769px]:line-clamp-2 min-[769px]:h-10 min-[769px]:text-[13px] min-[769px]:leading-5">{title}</span>
      <span className="flex min-h-[34px] min-w-0 items-center gap-2">
        <span className="inline-flex min-w-0 flex-wrap content-center items-baseline gap-x-2 gap-y-0">{price}</span>
        {priceMetadata}
      </span>
    </Link>
    {overlay && <div className="absolute right-0 top-0 z-[1]">{overlay}</div>}
    {action}
  </article>;
}
